import React from 'react';
import { Modal, Carousel } from 'react-bootstrap';
import { MdOutlineAccessTimeFilled } from 'react-icons/md';
import { FiLayers, FiAlertTriangle } from 'react-icons/fi';

const UnsafeEventsModal = ({
    showModal,
    onHide,
    currentHopper,
    currentRtcComponent,
    unsafeEvents,
    rtcUnsafeEvents,
    activeIndex,
    setActiveIndex,
    formatIfTimestamp
}) => {
    // Status Card Component (moved from Home.js)
    // console.log("unsafe events modal data --- >>> ", unsafeEvents)
    function StatusCard({ title, status, icon, isEyeIcon, bgColor = "white" }) {
        return (
            <div className="status-card" style={{ backgroundColor: bgColor }}>
                {/* Gradient corner */}
                <div
                    className={`status-gradient ${status ? "success" : "danger"}`}
                ></div>

                <div
                    className="p-3"
                    style={{ display: "flex", justifyContent: "space-between" }}
                >
                    <div className="d-flex align-items-center">
                        <div
                            className={`status-icon-wrapper ${status ? "success" : "danger"}`}
                        >
                            {icon}
                        </div>
                        <div>
                            <div className="status-title">{title}</div>
                            <div className={`status-value ${status ? "success" : "danger"}`}>
                                {status ? "Present" : "Removed"}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function formatComponentName(str) {
        if (!str) return '';
        const primixMatch = str.match(/^primix(\d+)$/i);
        if (primixMatch) {
            return `Premixer ${primixMatch[1]}`;
        }
        const finalMixerMatch = str.match(/^finalmixer(\d+)$/i);
        if (finalMixerMatch) {
            return `Final Mixture ${finalMixerMatch[1]}`;
        }
        // Default formatting: Capitalize first letter + space before last character
        if (str.length < 2) return str.charAt(0).toUpperCase();

        const firstChar = str.charAt(0).toUpperCase();
        const middlePart = str.slice(1, -1);
        const lastChar = str.charAt(str.length - 1);

        return firstChar + middlePart + ' ' + lastChar;
    }


    return (
        <Modal
            show={showModal}
            onHide={onHide}
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {formatComponentName(currentHopper || currentRtcComponent)}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="carousel-container">
                    {currentHopper ? (
                        // Turmeric unsafe events
                        <>
                            {/* <h5>{currentHopper === "hopper1" ? "Hopper 1" : "Hopper 2"}</h5> */}
                            <div className="text-center mb-3">
                                <span className="badge bg-primary">
                                    {activeIndex + 1} of {unsafeEvents[currentHopper].length}
                                </span>
                            </div>
                            <Carousel
                                className="w-full custom-carousel"
                                style={{ margin: "1rem 0" }}
                                interval={null}
                                activeIndex={activeIndex}
                                onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
                                indicators={true}
                            >
                                {unsafeEvents[currentHopper].map((event, index) => (
                                    <Carousel.Item key={index}>
                                        <div className="d-flex flex-row justify-content-center align-items-stretch gap-3 mx-3">
                                            <div style={{ width: "45%" }}>
                                                <StatusCard
                                                    title="Safety mesh"
                                                    status={event.status === "present"}
                                                    icon={<FiLayers className="status-icon" size={25} />}
                                                />
                                            </div>
                                            <div style={{ width: "45%" }}>
                                                <div className="status-card p-3 border rounded shadow-sm w-100">
                                                    <div
                                                        className="d-flex align-items-center"
                                                        style={{ margin: "auto 0" }}
                                                    >
                                                        <div className="me-3">
                                                            <MdOutlineAccessTimeFilled
                                                                style={{ width: "25px", height: "25px" }}
                                                            />
                                                        </div>
                                                        <div>
                                                            <div className="status-title">Unsafe Event Time</div>
                                                            <div>{formatIfTimestamp(event.timestamp)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                width: "80%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                margin: "2rem auto",
                                            }}
                                        >
                                            <img
                                                src={event.file_name}
                                                alt={`Unsafe Event - ${index + 1}`}
                                                className="img-fluid"
                                            />
                                        </div>
                                    </Carousel.Item>
                                ))}
                                {unsafeEvents[currentHopper].length === 0 && (
                                    <div className="text-center p-5">
                                        <p>No unsafe events recorded.</p>
                                    </div>
                                )}
                            </Carousel>
                        </>
                    ) : (
                        // RTC unsafe events
                        <>
                            {/* <h5>
                                {currentRtcComponent.charAt(0).toUpperCase() +
                                    currentRtcComponent.slice(1)}
                            </h5> */}

                            {/* Serial Number Display for RTC */}
                            <div className="text-center mb-3">
                                <span className="badge bg-primary">
                                    {activeIndex + 1} of {rtcUnsafeEvents[currentRtcComponent].length}
                                </span>
                            </div>

                            <Carousel
                                className="w-full custom-carousel"
                                style={{ margin: "1rem 0" }}
                                interval={null}
                                activeIndex={activeIndex}
                                onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
                                indicators={true}
                            >
                                {rtcUnsafeEvents[currentRtcComponent].map((event, index) => (
                                    <Carousel.Item key={index}>
                                        <div className="d-flex flex-row justify-content-center align-items-stretch gap-3 mx-3">
                                            <div style={{ width: "45%" }}>
                                                <StatusCard
                                                    title="Safety mesh"
                                                    status={event.testing}
                                                    icon={<FiAlertTriangle className="status-icon" size={25} />}
                                                />
                                            </div>
                                            <div style={{ width: "45%" }}>
                                                <div className="status-card p-3 border rounded shadow-sm w-100">
                                                    <div
                                                        className="d-flex align-items-center"
                                                        style={{ margin: "auto 0" }}
                                                    >
                                                        <div className="me-3">
                                                            <MdOutlineAccessTimeFilled
                                                                style={{ width: "25px", height: "25px" }}
                                                            />
                                                        </div>
                                                        <div>
                                                            <div className="status-title">Unsafe Event Time</div>
                                                            <div>{formatIfTimestamp(event.timestamp)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                width: "80%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                margin: "2rem auto",
                                            }}
                                        >
                                            <img
                                                src={event.file_name}
                                                alt={`Unsafe Event - ${index + 1}`}
                                                className="img-fluid"
                                            />
                                        </div>
                                    </Carousel.Item>
                                ))}
                                {rtcUnsafeEvents[currentRtcComponent].length === 0 && (
                                    <div className="text-center p-5">
                                        <p>No unsafe events recorded.</p>
                                    </div>
                                )}
                            </Carousel>
                        </>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default UnsafeEventsModal;